import { useState } from 'react';
import { Box, InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';

function DataTableSearchToolbar({ classes, ...props}) {
    const [searchValue, setSearchValue] = useState('');

    const handleSearchValueChange = (event) => {
        setSearchValue(event.target.value);
        props.onSearchChange(event);
    }

    return (
        <Box className={classes.searchToolbarOnly}>
            <TextField
                margin='dense'
                variant='outlined'
                onChange={handleSearchValueChange}
                placeholder='Recherche'
                value={searchValue}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='start'>
                            <Search />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
}

export default DataTableSearchToolbar;
